import React, { useEffect } from "react";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6 text-center text-indigo-700 drop-shadow-md tracking-wide">Privacy Policy</h1>

      <p className="mb-4">
        At <strong>Daily Dose Of Deals</strong>, we respect your privacy and are committed to protecting it. 
        We do not collect personally identifiable information unless you choose to provide it voluntarily.
      </p>

      <p className="mb-4">
        Our website may use cookies or similar technologies to improve your browsing experience, analyze site usage, 
        and provide relevant content. These cookies do not personally identify you and can be managed or disabled through your browser settings.
      </p>

      <p className="mb-4">
        We may use analytics or tracking tools to understand how visitors interact with our site and to enhance performance and user experience.
        We do not sell, trade, or rent personal information to any third party.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">California Privacy Rights</h2>
      <p className="mb-4">
        If you are a California resident, you have certain rights under the California Consumer Privacy Act (CCPA) 
        and the California Privacy Rights Act (CPRA), including the right to:
      </p>
      <ul className="list-disc list-inside mb-4 space-y-1">
        <li>Know what personal information we collect and how it is used.</li>
        <li>Request deletion of your personal information.</li>
        <li>Opt out of the sale or sharing of personal data.</li>
        <li>Not be discriminated against for exercising these rights.</li>
      </ul>

      <p className="mb-4">
        We do not sell personal data. Some information collected through cookies or analytics tools may be considered “sharing” under California law. 
        You can contact us through the Contact page to make a request related to your privacy rights.
      </p>

      <p>
        By using our website, you consent to this Privacy Policy and the use of cookies as described above.
      </p>
    </div>
  );
}
